
var $ = window.jQuery;
var config = require('./common/config')

$(function() {
  $(".slide-box").slide({
    mainCell:".bd ul",
    effect:"fold",
    delayTime:500,
    interTime:3500,
    autoPlay:true
  })

  //导航栏颜色
  $('#header ul li:eq(0) a').attr('class','activity');
  // 新闻资讯 接口
  loadList();

  function loadList() {
    $.ajax({
      url: config.newsURI  + '/main/WebService.asmx/getnewstitles',
      type: 'POST',
      data: {
        page: 0,
        rows: 4,
        rowminId: 10000000
      },
      dataType: 'xml',
      success: function(result) {
        // 嗅探
        var browserName = navigator.userAgent.toLowerCase();
        if(/msie/i.test(browserName) && !/opera/.test(browserName)){
          // IE浏览器获取数据方法
          var data = JSON.parse($(result).find('string').text());
        }else {
          // 现代浏览器获取数据方法
          var data = JSON.parse($(result).find('string').html());
        }
        // IE下查看属性
        // for (var key in $(result).find('string')) {
        //   console.log(key)
        // }
        // 设置默认info-detail id值
        // localStorage.setItem('id', data.data[0].id)

        // 获取默认图片
        $.ajax({
          url: config.newsURI + '/main/WebService.asmx/getnewsdetail',
          type: 'POST',
          data: {
            newsid:data.data[0].id
          },
          dataType: 'xml',
          success: function(result) {
            if(/msie/i.test(browserName) && !/opera/.test(browserName)){
              // IE浏览器获取数据方法
              var ImgData = JSON.parse($(result).find('string').text());
            }else {
              // 现代浏览器获取数据方法
              var ImgData = JSON.parse($(result).find('string').html());
            }
              $('#information .pic').html('<a href="/main/arena/app/info-detail.html?page=' + ImgData.data.titleinfo.id + '" target="_blank" ><img style="border:none" src="' + '/' + ImgData.data.thumbnail + '" alt="' + ImgData.data.titleinfo.title + '"></a><p>' + ImgData.data.titleinfo.title + '</p>')
              $('#information .pic p').click(function() {
                window.open("/main/arena/app/info-detail.html?page=" + ImgData.data.titleinfo.id)
              })
          },
          error: function(result) {
            console.log("image get error!");
          }
        })

        // 插入资讯 <li></li>
        for(var i = 0; i < data.data.length; i++) {
          var list = data.data[i];
          $('#information .content ul').append( '<li data-id="' + list.id + '"><a href="/main/arena/app/info-detail.html?page=' + list.id + '" target="_blank"><span>' + changeTime(list.Createtime) + '</span><span>' + list.title + '</span></a></li> ');
        }
        $('#information .content ul').append('<li style="height:24px"><a href="/main/arena/app/information.html" target="_blank">更多资讯</a><p class="icon-Shape" style="padding-top:3px"></p></li>')

        
        // 每条资讯切换图片和id值
        $('#information .content ul li').each(function(i) {
          $('#information .content ul li').eq(i).hover(function() {
            if(i == 4) {
              return false
            }
            // localStorage.setItem('id', $('#information .content ul li').eq(i).attr('data-id'))

            $.ajax({
              url: config.newsURI + '/main/WebService.asmx/getnewsdetail',
              type: 'POST',
              data: {
                newsid:data.data[i].id
              },
              dataType: 'xml',
              success: function(result) {
                if(/msie/i.test(browserName) && !/opera/.test(browserName)){
                  // IE浏览器获取数据方法
                  var ImgData = JSON.parse($(result).find('string').text());
                }else {
                  // 现代浏览器获取数据方法
                  var ImgData = JSON.parse($(result).find('string').html());
                }
                $('#information .pic').html('<a href="/main/arena/app/info-detail.html?page=' + ImgData.data.titleinfo.id + '" target="_blank" ><img style="border:none" src="' + '/' + ImgData.data.thumbnail + '" alt="' + ImgData.data.titleinfo.title + '"></a><p>' + ImgData.data.titleinfo.title + '</p>')
                $('#information .pic p').click(function() {
                  window.open("/main/arena/app/info-detail.html?page=" + ImgData.data.titleinfo.id)
                })
              },
              error: function(result) {
                console.log("image get error!");
              }
            })
          })
        });


        // 点击更多图标跳转页面
        $('#information .content ul li .icon-Shape').click(function() {
          window.open('/main/arena/app/information.html')
        })
      },
      error: function(result) {
        console.log("news get error!");
      }
    })
  }

  // 日期转换
  function changeTime(result) {
    var date = new Date(result);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    if(month<10) {
      month = "0" + month
    }
    if(day<10) {
      day = "0" + day
    }
    result = year + '-' + month + '-' + day;
    return result;
  }
})
